export default __webpack_public_path__ + "static/media/closet5-after2-480w.4094e5e0.webp";